import React from "react";
import styled from "styled-components";

const ProjectSectionSkillsElement = styled.div`
  max-width: 42rem;
  margin: 0 auto;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  column-gap: 0;
  row-gap: var(--spacing-tiny);

  @media (min-width: 600px) {
    max-width: 59rem;
  }

  @media (min-width: 768px) {
    width: 100%;
  }

  @media (pointer: coarse) {
    max-width: 41rem;
    row-gap: var(--spacing-tiny);
    margin-bottom: var(--spacing-small);
  }
  @media (pointer: coarse) and (min-width: 768px) {
    column-gap: var(--spacing-medium);
  }
`;

const ProjectSectionSkills = ({ children }) => {
  return <ProjectSectionSkillsElement children={children}>{children}</ProjectSectionSkillsElement>;
};

export default ProjectSectionSkills;
